<template>
  <div class="lead-feature">
    <div class="image-box">
      <v-img v-if="!isLoading && logo" :src="logo.url" :width="350" :max-height="350">
        <template v-slot:placeholder>
          <div class="flex-center">
            <v-progress-circular color="primary" indeterminate></v-progress-circular>
          </div>
        </template>
        <template v-slot:error>
          <v-img src="../assets/myket-logo.png"></v-img>
        </template>
      </v-img>
      <div class="flex-center" v-else-if="!isLoading && !logo">
        <div class="text"> {{ $t('noLogo') }} </div>
      </div>
      <div class="flex-center" v-if="isLoading">
        <v-progress-circular color="primary" indeterminate></v-progress-circular>
      </div>
    </div>
    <v-skeleton-loader type="heading,subtitle" class="feature-box" :loading="isLoading">
      <v-list-item lines="two" :subtitle="subTitle" :title="title"></v-list-item>
    </v-skeleton-loader>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      isOwner: false,
      logo: null,
      title: '',
      subTitle: '',
      theme: ''
    };
  },
  computed: {
    ...mapGetters({
      project: "project/getProject",
      isLoading: "project/getIsLoading",
      language: "appSetting/getLanguage",
    }),
  },
  watch: {
    project: {
      handler(p) {
        if (p.setting) {
          const { logo, bookingTheme } = p.setting
          if (logo)
            this.logo = logo
          if (bookingTheme)
            this.theme = bookingTheme

        } else {
          this.logo = null
          this.theme = ''
        }
        this.setTitle(this.language)
      },
      deep: true
    },
    language: {
      handler(newLang, oldLang) {
        if (newLang && newLang != oldLang) {
          this.setTitle(newLang)
        }
      },
    }
  },
  mounted() {
    this.isOwner = true
  },
  methods: {
    setTitle(lang) {
      if (this.project?.setting) {
        const { bookingSubTitle, bookingTitle, bookingSubTitleEn, bookingTitleEn, bookingSubTitleLo, bookingTitleLo } = this.project.setting
        if (lang == 'en') {
          this.title = bookingTitleEn || this.$t('noData')
          this.subTitle = bookingSubTitleEn || this.$t('noData')
        } else if (lang == 'th') {
          this.title = bookingTitle || this.$t('noData')
          this.subTitle = bookingSubTitle || this.$t('noData')
        } else if (lang == 'lo') {
          this.title = bookingTitleLo || this.$t('noData')
          this.subTitle = bookingSubTitleLo || this.$t('noData')
        } else {
          this.title = 'สำหรับผู้ที่สนใจทำการค้ากับเรา'
          this.subTitle = 'ติดต่อเรา โทร 061-884-5566, 099-415-7878'
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.lead-feature {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  padding: 0 15px 15px;
  flex-direction: column;
  // max-width: 600px;
  // @media (max-width: 414px) {
  //   padding: 0;
  // }


  .image-box {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 200px;
    height: 100%;
    // margin: 0 0 10px 0;
    position: relative;
    width: 100%;
    max-width: 350px;
    max-height: 350px;
    background: #FFFFFF;
    border-radius: 10px;
    box-shadow: var(--v-box-shadow);
    padding: 15px;

    @media (max-width: 700px) {
      max-width: 300px;
      max-height: 300px;
    }

    .flex-center {
      display: flex;
      height: 100%;
      width: 100%;
      justify-content: center;
      align-items: center;

      .text {
        font-size: 25px;
        color: gray;
      }
    }

    img {
      width: 100%;
      height: auto;
      object-fit: contain;
      object-position: center;
    }
  }

  .feature-box {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: flex-start;
    margin-top: 20px;
    // padding: 0 30px;
    min-width: 300px;
    max-width: 600px;
    width: 100%;
    background: transparent;

    @media (max-width: 414px) {
      padding: 0;
      margin-bottom: 0px;
    }

    .v-list-item:deep() {

      .v-list-item-title {
        text-align: center;
        color: rgb(var(--v-theme-primary));
        font-size: 25px;
        font-weight: bold;
        text-wrap: pretty;
        opacity: 1;
      }

      .v-list-item-subtitle {
        text-align: center;
        color: rgb(var(--v-theme-primary-darken-1));
        font-size: 18px;
        margin-top: 10px;
        text-wrap: pretty;
        opacity: 1;
        letter-spacing: 0;
        line-height: 25px;
      }

      @media (max-width: 836px) {
        .v-list-item-title {
          font-size: 20px;
        }

        .v-list-item-subtitle {
          font-size: 16px;
        }
      }

      @media (max-width: 400px) {
        .v-list-item-title {
          font-size: 18px;
        }

        .v-list-item-subtitle {
          font-size: 14px;
        }
      }
    }
  }



}
</style>
